import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import {Router, ActivatedRoute} from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-general-settings',
    templateUrl: './general-settings.component.html',
    styleUrls: ['./general-settings.component.css'],
    standalone: false
})
export class GeneralSettingsComponent implements OnInit {
  categories: Array<any> = [];
  isLoading: boolean = true;
  userPrivileges: Set<string> = new Set();
  activeComponent: string = 'Account';
  activeSubOption: string = 'Candidate Source'; 

  platformOptions: string[] = [];
  platformOptionPrivileges: { [key: string]: string } = {
    'Candidate Source': 'candidate_source.view',
    'Event Category': 'event_category.view',
    'Event Type': 'event_type.view',
    'Role Type': 'role_type.view'
  };

  createNewTemplate$: Subject<void> = new Subject<void>();
  createNewForm$: Subject<void> = new Subject<void>();
  activeUserManagementTab: WritableSignal<"users" | "roles"> = signal<"users" | "roles">("users");
  addUser$: Subject<void> = new Subject<void>();
  addRole$: Subject<void> = new Subject<void>();

  constructor(
    private breadcrumbService: BreadcrumbService  ,
    private globalService: GlobalServicesService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.globalService.getUserProfileFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          let companyDetails = {
            company_metadata: res.body.company_metadata,
            company_settings: res.body.company_settings,
            company_details: res.body.company_details,
          };
          let letter = ['D', 'Y'];
          companyDetails.company_settings.date_format = companyDetails.company_settings.date_format?.toString().replace( 
              new RegExp(letter.join('|'), 'g'),(match: string) => match.toLowerCase());
          companyDetails.company_settings.time_format = companyDetails.company_settings.time_format == '24' ? 'HH:mm' : 'hh:mm';
          localStorage.setItem('company-details', JSON.stringify(companyDetails));
        }
      }
    });
  }

  ngOnInit(): void {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    
    this.getCategories();  this.activatedRoute.queryParams.subscribe(params => {
      const menu = params['menu'];
      if (menu) {
        const found = this.categories.find(cat => 
          cat.name.replace(/ /g, '-').toLowerCase() === menu
        );
        if (found) {
          this.openCategory(found.name);
        }
      }
    });
    this.updateBreadcrumb();
  }

  updateBreadcrumb(): void {
    this.breadcrumbService.set('@settings', 'Settings');
    if (this.activeComponent) {
      this.breadcrumbService.set('@settingsChild', this.activeComponent);
    }
  }  

  getCategories = () => {
    this.isLoading = false;
    const showPlatformConfig = Object.values(this.platformOptionPrivileges).some(
      privilege => this.userPrivileges.has(privilege)
    );
    this.platformOptions = Object.keys(this.platformOptionPrivileges).filter(
      option => this.userPrivileges.has(this.platformOptionPrivileges[option])
    );
    

    const privilegeMap = [
      { name: "Account", isActive: true, icon: "assets/icons-svg/profile.svg" },
      { name: "Company Details", isActive: true, icon: "assets/icons-svg/company details.svg", privilege: ['company_details.view', 'branch.view', 'date_time_format.view'] },
      ...(showPlatformConfig && this.platformOptions.length > 0 ? [{ name: "Configuration", isActive: true, icon: "assets/icons-svg/configuration.svg" }] : []),
      { name: "User Management", isActive: true, icon: "assets/icons-svg/people.svg", privilege: ["user.view","role.view"] },
      { name: "Email Templates", isActive: true, icon: "assets/icons-svg/email logo.svg", privilege: ["email_template.view"] },
      { name: "Form Builder", isActive: true, icon: "assets/icons-svg/note icon.svg", privilege: ["form_builder.view"] },
      { name: "Integrations", isActive: true, icon: "assets/icons-svg/app.svg", privilege: ["integration.view"] },
      // { name: 'Primary Account', isActive: true },
      // { name: 'Company Details', privilege: 'company_details.view' },
      // { name: 'Branches', privilege: 'branch.view' },
      // { name: 'Date and Time', privilege: 'date_time_format.view' },
      // ...(showPlatformConfig && this.platformOptions.length > 0
      //   ? [{ name: 'Platform Configuration', isActive: false }]: []),
      // { name: 'User Management', privilege: 'role.view' },
      // // { name: 'Manage Users', privilege: 'user.view' },
      // { name: 'Email Template', privilege: 'email_template.view' },
      // { name: 'Form Builder', privilege: 'form_builder.view' },
    ];
    this.categories = privilegeMap
      .filter(cat => !cat.privilege || cat.privilege.some(priv => this.userPrivileges.has(priv)))
      .map((cat, index) => ({
        name: cat.name,
        isActive: index === 0,
        icon: cat.icon
      }));
  };

  openCategory = (name: string) => {
    this.activeComponent = name;
    this.categories.forEach((each) => {
      each.isActive = this.activeComponent === each.name;
    });
    const menuParam = name.replace(/ /g, '-').toLowerCase();
    let queryParams: any = { menu: menuParam };
    if (menuParam === 'form-builder') {
      queryParams['category'] = this.activatedRoute.snapshot.queryParamMap.get('category') || 'registration';
    }
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      replaceUrl: true
    });
  
    if (name === 'Platform Configuration' && this.platformOptions.length > 0) {
      this.activeSubOption = this.platformOptions[0];
    }  
    if(name === "User Management") {
      this.activeUserManagementTab.set("users")
    }
    this.updateBreadcrumb();
  };

  setActiveSubOption(option: string) {
    this.activeSubOption = option;
  }

  handleKeydown(event: KeyboardEvent, categoryName: string): void {
    if (event.key === 'Enter') {
      this.openCategory(categoryName);
    }
  }

  userManagementAddAction() {
    if(this.activeUserManagementTab() === "users") {
      this.addUser$.next();
    } else {
      this.addRole$.next();
    }
  }
}
